package ru.it_mozaika.sender.js.application.frames.catalog

import io.ktor.client.call.*
import io.ktor.http.*
import mui.material.*
import mui.material.styles.Theme
import mui.material.styles.TypographyVariant
import mui.material.styles.useTheme
import mui.system.responsive
import mui.system.sx
import react.*
import react.router.useParams
import ru.it_mozaika.sender.common.models.Product
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.sender.js.application.context.BackdropContext
import ru.it_mozaika.sender.js.application.context.CategoriesContext
import ru.it_mozaika.sender.js.application.context.RequestResultContext
import ru.it_mozaika.sender.js.application.frames.MainCard
import web.cssom.*
import web.window.WindowTarget

val ProductFrame = VFC {
    val params = useParams()
    val id = params["id"].orEmpty()
    var product by useState<Product>()
    val requestContext = useContext(RequestResultContext)
    val backdrop = useContext(BackdropContext)
    val theme = useTheme<Theme>()
    val (prettyName, setPrettyName) = useState("")
    val categoriesContext = useContext(CategoriesContext)
    val productCategories = useMemo(categoriesContext.categories, product) {
        categoriesContext.categories.filter {
            product?.category?.contains(it.id) ?: false
        }
    }

    fun getProduct() {
        backdrop.show()
        Http.get("/catalog/products/$id", query = mapOf("id" to id)) { response ->
            if (response.status == HttpStatusCode.OK) {
                product = response.body()
                backdrop.hide()
            } else {
                backdrop.hide()
                requestContext.handleRequestRespond(response)
            }
        }
    }

    fun updatePrettyName() {
        backdrop.show()
        Http.get("/catalog/products/$id/update", query = mapOf("id" to id, "prettyName" to prettyName)) { response ->
            if (response.status != HttpStatusCode.OK) {
                backdrop.hide()
                requestContext.handleRequestRespond(response)
            } else {
                getProduct()
                backdrop.hide()
            }
        }
    }
    useEffect(id) {
        getProduct()
    }
    useEffect(product) {
        setPrettyName(product?.prettyName ?: "")
    }

    Card {
        sx {
            this.backgroundColor = theme.palette.grey["100"].unsafeCast<Color>()
        }
        CardHeader {
            this.title = ReactNode(" ID ${product?.id ?: "---"}")

        }
        Grid {
            container = true
            direction = responsive(GridDirection.row)
            spacing = responsive(2)
            Grid {
                item = true
                asDynamic().xs = 4
                Card {
                    sx {

                        ":hover" {
                            boxShadow = BoxShadow(0.px, 2.px, 14.px, 0.px, Color("rgb(32 40 45 / 8%)"))
                        }
                    }
                    CardHeader {
                        title = Grid.create {
                            container = true
                            direction = responsive(GridDirection.row)
                            sx {
                                alignItems = AlignItems.center
                                justifyContent = JustifyContent.spaceBetween
                            }
                            Grid {
                                item = true
                                asDynamic().xs = 6
                                Link {
                                    href = product?.url ?: ""
                                    +product?.name
                                    target = WindowTarget._blank
                                }
                            }
                            Grid {
                                item = true
                                asDynamic().xs = 6
                                Stack {
                                    direction = responsive(StackDirection.row)
                                    spacing = responsive(2)
                                    sx {
                                        justifyContent = JustifyContent.flexEnd
                                        alignItems = AlignItems.center
                                    }
                                    Stack {
                                        direction = responsive(StackDirection.row)
                                        spacing = responsive(1)
                                        sx {
                                            alignItems = AlignItems.center
                                        }
                                        Typography {
                                            +"Цена:"
                                        }
                                        Typography {
                                            if (product?.price != null) {
                                                +"${product?.price.toString()} руб."
                                            } else {
                                                +"--- руб."
                                            }
                                        }
                                    }
                                    Stack {
                                        direction = responsive(StackDirection.row)
                                        spacing = responsive(1)

                                        sx {
                                            alignItems = AlignItems.center
                                        }
                                        Typography {
                                            +"Старая цена:"
                                        }

                                        Typography {
                                            if (product?.oldPrice != null) {
                                                +product?.oldPrice.toString()
                                            } else {
                                                +"--- руб."
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    CardMedia {
                        asDynamic().component = "img"
                        image = product?.picture ?: ""
                        asDynamic().alt = product?.name ?: ""
                        sx {
                            overflow = Overflow.visible
                            maxHeight = 400.px
                            margin = 12.px
                        }
                    }
                }
            }
            Grid {
                sx {
                    "& .MuiPaper-root" {
                        height = 100.pct
                    }
                }
                item = true
                asDynamic().xs = 8
                MainCard {
                    title = "Информация о товаре"
                    actions = Chip.create {
                        variant = ChipVariant.filled
                        icon = if (product?.available == true) {
                            mui.icons.material.CheckCircleOutlineSharp.create {
                                color = SvgIconColor.success
                            }
                        } else {
                            mui.icons.material.BlockSharp.create {
                                color = SvgIconColor.error
                            }
                        }
                        color = if (product?.available == true) {
                            ChipColor.success
                        } else {
                            ChipColor.error
                        }
                        label =
                            ReactNode(if (product?.available != true) "Недоступен для продажи" else "Доступен для продажи")
                    }
                    Stack {
                        direction = responsive(StackDirection.column)
                        spacing = responsive(2)
                        Grid {
                            item = true
                            asDynamic().xs = 12
                            Stack {
                                direction = responsive(StackDirection.row)
                                spacing = responsive(1)
                                sx {
                                    alignItems = AlignItems.center
                                }
                                Typography {
                                    +"Красивое наименование:"
                                }
                                FormControl {
                                    variant = FormControlVariant.outlined
                                    fullWidth = true
                                    OutlinedInput {
                                        color = InputBaseColor.secondary
                                        value = prettyName
                                        onChange = { event ->
                                            val text = event.target.asDynamic().value as String
                                            setPrettyName(text)
                                        }
                                    }
                                }
                                Stack {
                                    direction = responsive(StackDirection.row)
                                    spacing = responsive(2)
                                    Tooltip {
                                        title = ReactNode("Подтвердить")
                                        IconButton {
                                            disabled = prettyName == product?.prettyName
                                            mui.icons.material.DoneSharp {
                                                color =
                                                    if (prettyName == product?.prettyName) SvgIconColor.inherit else SvgIconColor.success
                                            }
                                            onClick = {
                                                updatePrettyName()
                                            }
                                        }
                                    }
                                    Tooltip {
                                        title = ReactNode("Отменить")
                                        IconButton {
                                            disabled = prettyName == product?.prettyName
                                            mui.icons.material.ClearSharp {

                                                color =
                                                    if (prettyName == product?.prettyName) SvgIconColor.inherit else SvgIconColor.error
                                            }
                                            onClick = {
                                                setPrettyName(product?.prettyName ?: "")
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        Grid {
                            item = true
                            asDynamic().xs = 12
                            Grid {
                                direction = responsive(GridDirection.row)
                                spacing = responsive(2)
                                container = true
                                sx {
                                    alignItems = AlignItems.center
                                }
                                Grid {
                                    item = true
                                    asDynamic().xs = 4
                                    Stack {
                                        sx {
                                            alignItems = AlignItems.center
                                        }
                                        direction = responsive(StackDirection.row)
                                        spacing = responsive(1)
                                        Typography {
                                            +"Код поставщика:"
                                        }
                                        FormControl {
                                            variant = FormControlVariant.outlined
                                            fullWidth = true
                                            disabled = true
                                            OutlinedInput {
                                                disabled = true
                                                color = InputBaseColor.secondary
                                                value = product?.vendorCode ?: ""

                                            }
                                        }
                                    }
                                }
                                Grid {
                                    item = true
                                    asDynamic().xs = 4
                                    Stack {
                                        sx {
                                            alignItems = AlignItems.center
                                        }
                                        direction = responsive(StackDirection.row)
                                        spacing = responsive(1)
                                        Typography {
                                            +"Поставщик:"
                                        }
                                        FormControl {
                                            variant = FormControlVariant.outlined
                                            fullWidth = true
                                            disabled = true
                                            OutlinedInput {
                                                disabled = true
                                                color = InputBaseColor.secondary
                                                value = product?.vendor ?: "---"
                                            }
                                        }
                                    }
                                }
                                Grid {
                                    item = true
                                    asDynamic().xs = 4
                                    Stack {
                                        sx {
                                            alignItems = AlignItems.center
                                        }
                                        spacing = responsive(1)
                                        direction = responsive(StackDirection.row)
                                        Typography {
                                            +"Категории:"
                                        }
                                        FormControl {
                                            fullWidth = true
                                            variant = FormControlVariant.outlined
                                            OutlinedInput {
                                                color = InputBaseColor.secondary
                                                value = productCategories.joinToString(",") { it.name }
                                                disabled = true
                                            }
                                        }
                                    }
                                }
                                product?.params?.forEach { (title, value) ->
                                    Grid {
                                        item = true
                                        asDynamic().xs = 4
                                        Stack {
                                            sx {
                                                alignItems = AlignItems.center
                                            }
                                            spacing = responsive(1)
                                            direction = responsive(StackDirection.row)
                                            Typography {
                                                +"$title:"
                                            }
                                            FormControl {
                                                disabled = true
                                                variant = FormControlVariant.outlined
                                                fullWidth = true
                                                OutlinedInput {
                                                    color = InputBaseColor.secondary
                                                    this.value = value
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
            Grid {
                item = true
                asDynamic().xs = 12
                MainCard {
                    title = "Описание"
                    Typography {
                        variant = TypographyVariant.body2
                        asDynamic().color = theme.palette.text.secondary
                        +product?.description
                    }
                }
            }
        }
    }
}
